<template>
  <form-wizard ref="add_checkers_form" color="#39C0ED" @on-complete="addConfirmation">
    <h2 slot="title"></h2>   
      <tab-content title="Check Information" :before-change="() => validateStep('childCheckComponent')">
        <check-card  :checker="checker" ref="childCheckComponent"/>
      </tab-content>
      <tab-content title="Bagian Body">
        <bag-body-card  :checker.sync="checker" ref="childBagBody"/>
         
      </tab-content>
      <tab-content title="Bagian Dalam Mobil">
        <bag-dalam-card  :checker.sync="checker" ref="childBagDalamComponent"/>
         
      </tab-content>
      <tab-content title="Bagian Luar Mobil">
        <bag-luar-card  :checker="checker" ref="childBagLuarComponent"/>
         
      </tab-content>
      <tab-content title="Bagian Mesin Mobil">
        <bag-mesin-card  :checker="checker" ref="childBagMesinComponent"/>
         
      </tab-content>
      <tab-content title="Perlengkapan Lain Mobil">
        <per-lain-card  :checker="checker" ref="childPerLainComponent"/>
         
      </tab-content>
      
      <tab-content title="Kelengkapan Taksi">
        <kel-taksi-card  :checker="checker" ref="childKelTaksiComponent"/>
         
      </tab-content>
 
  </form-wizard>
</template>
 
<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// import komponen
import CheckCard from "@/pages/Dashboard/Workshop/Checker/ComponentForm/CheckCard.vue";
import BagianDalamCard from "@/pages/Dashboard/Workshop/Checker/ComponentForm/BagianDalamCard.vue";
import BagianLuarCard from "@/pages/Dashboard/Workshop/Checker/ComponentForm/BagianLuarCard.vue";
import BagianMesinCard from "@/pages/Dashboard/Workshop/Checker/ComponentForm/BagianMesinCard.vue";
import PerLainCard from "@/pages/Dashboard/Workshop/Checker/ComponentForm/PerlengkapanLainCard.vue";
import KelTaksiCard from "@/pages/Dashboard/Workshop/Checker/ComponentForm/KelengkapanTaksiCard.vue";
import BagianBodyCard from "@/pages/Dashboard/Workshop/Checker/ComponentForm/BagianBodyCard.vue";
import Swal from 'sweetalert2';

//  extend('useppn', {
//   ...required,
//   message: 'Use PPN field is required'
//   });
//   extend('dealername', {
//     ...required,
//     message: 'Dealer Name field is required'
//   });

export default {
  name: "add-checkers",

  // props: {
  //   checker: Object,
  // },

  components: {
    // ValidationError,
    FormWizard,
    TabContent,
    "check-card": CheckCard,
    "bag-dalam-card": BagianDalamCard,
    "bag-luar-card": BagianLuarCard,
    "bag-mesin-card": BagianMesinCard,
    "per-lain-card": PerLainCard,
    "kel-taksi-card": KelTaksiCard,
    "bag-body-card": BagianBodyCard,
    
      
  },

  mixins: [formMixin],

  data: () => ({
    checker: [],
  }),
  
  created() {
    // this.getLastNo();
  },
  
  methods: {
    // async getLastNo(){
    //   //  await this.$store.dispatch("workshop_checker/last_no")
    //   //  this.checker.checker_no =  await this.$store.getters["workshop_checker/checker"]
    //   //this.$refs.childServiceInfoComponent.focusNoEstimate();
    // },
    
    async addConfirmation() {
     
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.AddChecker()
        }
      });
    },

    //fungsi untuk mengirim data ke server
    async AddChecker() {
      //ambil data dari child page
      this.$refs.childCheckComponent.getData()
      this.$refs.childBagDalamComponent.getData()
      this.$refs.childBagLuarComponent.getData()
      this.$refs.childBagMesinComponent.getData()
      this.$refs.childPerLainComponent.getData()
      this.$refs.childKelTaksiComponent.getData()
      this.$refs.childBagBody.getData()
      //set var data yang akan dikirm ke server
      const data = {
        type: "workshop_checkers",
        // checker_no: this.checker.checker_no,
        checker_vehicle_id: this.checker.checker_vehicle_id,
        checker_pool: this.checker.checker_pool,
        checker_date: this.checker.checker_date,
        checker_type: this.checker.checker_type,
        checker_bbm: this.checker.checker_bbm,
        checker_km: this.checker.checker_km,
        checker_km_mspf : this.checker.checker_km_mspf,
        checker_rit: this.checker.checker_rit,
        checker_drop: this.checker.checker_drop,
        checker_berbau: this.checker.checker_berbau,
        checker_goresan: this.checker.checker_goresan,
        checker_kunci: this.checker.checker_kunci,
        checker_kunci_cadangan : this.checker.checker_kunci_cadangan,
        checker_kunci_cadangan_remark : this.checker.checker_kunci_cadangan_remark,
        checker_kunci_remark: this.checker.checker_kunci_remark,
        checker_putaran_mesin: this.checker.checker_putaran_mesin,
        checker_putaran_mesin_remark: this.checker.checker_putaran_mesin_remark,
        checker_rem_tangan: this.checker.checker_rem_tangan,
        checker_rem_tangan_remark: this.checker.checker_rem_tangan_remark,
        checker_pedal:  this.checker.checker_pedal,
        checker_pedal_remark:  this.checker.checker_pedal_remark,
        checker_posisi_stir_dan_klakson: this.checker.checker_posisi_stir_dan_klakson,
        checker_posisi_stir_dan_klakson_remark: this.checker.checker_posisi_stir_dan_klakson_remark,
        // checker_kartu_oli_dan_maintenance: this.checker.checker_kartu_oli_dan_maintenance,
        // checker_kartu_oli_dan_maintenance_remark: this.checker.checker_kartu_oli_dan_maintenance_remark,
        checker_wiper_depan_belakang: this.checker.checker_wiper_depan_belakang,
        checker_wiper_depan_belakang_remark: this.checker.checker_wiper_depan_belakang_remark,
        checker_lampu_sign: this.checker.checker_lampu_sign,
        checker_lampu_sign_remark: this.checker.checker_lampu_sign_remark,
        checker_lampu_baca: this.checker.checker_lampu_baca,
        checker_lampu_baca_remark: this.checker.checker_lampu_baca_remark,
        checker_lampu_utama_depan: this.checker.checker_lampu_utama_depan,
        checker_lampu_utama_depan_remark: this.checker.checker_lampu_utama_depan_remark,
        checker_lampu_rem: this.checker.checker_lampu_rem,
        checker_lampu_rem_remark: this.checker.checker_lampu_rem_remark,
        checker_lampu_mundur: this.checker.checker_lampu_mundur,
        checker_lampu_mundur_remark: this.checker.checker_lampu_mundur_remark,
        checker_power_window: this.checker.checker_power_window,
        checker_power_window_remark: this.checker.checker_power_window_remark,
        checker_central_lock: this.checker.checker_central_lock,
        checker_central_lock_remark: this.checker.checker_central_lock_remark,
        checker_elektrik_mirror: this.checker.checker_elektrik_mirror,
        checker_elektrik_mirror_remark: this.checker.checker_elektrik_mirror_remark,
        checker_ac: this.checker.checker_ac,
        checker_ac_remark: this.checker.checker_ac_remark,
        checker_stnk: this.checker.checker_stnk,
        checker_stnk_remark: this.checker.checker_stnk_remark,
        // checker_lighter: this.checker.checker_lighter,
        // checker_lighter_remark: this.checker.checker_lighter_remark,
        checker_safety_belt: this.checker.checker_safety_belt,
        checker_safety_belt_remark: this.checker.checker_safety_belt_remark,
        checker_head_rest: this.checker.checker_head_rest,
        checker_head_rest_remark: this.checker.checker_head_rest_remark,
        checker_head_unit: this.checker.checker_head_unit,
        checker_head_unit_remark: this.checker.checker_head_unit_remark,
        checker_remote_head_unit: this.checker.checker_remote_head_unit,
        checker_remote_head_unit_remark: this.checker.checker_remote_head_unit_remark,
        checker_sarung_jok: this.checker.checker_sarung_jok,
        checker_sarung_jok_remark: this.checker.checker_sarung_jok_remark,
        checker_karpet_dasar: this.checker.checker_karpet_dasar,
        checker_karpet_dasar_remark: this.checker.checker_karpet_dasar_remark,
        checker_karpet_karet: this.checker.checker_karpet_karet,
        checker_karpet_karet_remark: this.checker.checker_karpet_karet_remark,
        // checker_asbak_depan_belakang: this.checker.checker_asbak_depan_belakang,
        // checker_asbak_depan_belakang_remark: this.checker.checker_asbak_depan_belakang_remark,
        checker_speedometer: this.checker.checker_speedometer,
        checker_speedometer_remark: this.checker.checker_speedometer_remark,
        checker_cat_kap_mesin : this.checker.checker_cat_kap_mesin,
        checker_cat_bumper_spakboard : this.checker.checker_cat_bumper_spakboard,
        checker_cat_pintu : this.checker.checker_cat_pintu,
        checker_mika_lampu : this.checker.checker_mika_lampu,
        checker_ban : this.checker.checker_ban,
        checker_velg : this.checker.checker_velg,
        checker_dop_roda : this.checker.checker_dop_roda,
        checker_kembang_ban : this.checker.checker_kembang_ban,
        checker_kaca_film : this.checker.checker_kaca_film,
        checker_gril_depan : this.checker.checker_gril_depan,
        checker_gril_belakang : this.checker.checker_gril_belakang,
        checker_list_plang_kanan : this.checker.checker_list_plang_kanan,
        checker_list_plang_kiri : this.checker.checker_list_plang_kiri,
        checker_kunci_pintu : this.checker.checker_kunci_pintu,
        checker_emblem_sticker : this.checker.checker_emblem_sticker,
        checker_ban_cadangan : this.checker.checker_ban_cadangan,
        checker_oli_mesin : this.checker.checker_oli_mesin,
        checker_air_dan_tutup_radiator : this.checker.checker_air_dan_tutup_radiator,
        checker_accu :this.checker.checker_accu,
        checker_tali_kipas : this.checker.checker_tali_kipas,
        checker_minyak_rem : this.checker.checker_minyak_rem,
        checker_minyak_rem_remark : this.checker.checker_minyak_rem_remark,
        checker_dongkrak : this.checker.checker_dongkrak,
        checker_ban_serep_dan_kunci_roda : this.checker.checker_ban_serep_dan_kunci_roda,
        checker_segitiga_pengaman : this.checker.checker_segitiga_pengaman,
        checker_karpet_bagasi : this.checker.checker_karpet_bagasi,
        checker_p3k : this.checker.checker_p3k,
        checker_mahkota : this.checker.checker_mahkota,
        checker_argometer : this.checker.checker_argometer,
        checker_lampu_bahaya : this.checker.checker_lampu_bahaya,
        checker_sticker_atribut_taksi : this.checker.checker_sticker_atribut_taksi,
        checker_lampu_vacant : this.checker.checker_lampu_vacant,
        checker_images_bagian_dalam : this.checker.images_bagian_dalam,
        checker_images_bagian_luar : this.checker.images_bagian_luar,
        checker_images_bagian_mesin : this.checker.images_bagian_mesin,
        checker_images_bagian_body : this.checker.images_bagian_body,
        checker_images_bagian_taxi : this.checker.images_bagian_taxi,
        checker_images_bagian_lain : this.checker.images_bagian_lain,
        checker_gril_depan_remark : this.checker.checker_gril_depan_remark,
        checker_gril_belakang_remark : this.checker.checker_gril_belakang_remark,
        checker_list_plang_kanan_remark : this.checker.checker_list_plang_kanan_remark,
        checker_list_plang_kiri_remark : this.checker.checker_list_plang_kiri_remark,
        checker_kap_mesin_remark : this.checker.checker_kap_mesin_remark,
        checker_fender_depan_kiri_remark : this.checker.checker_fender_depan_kiri_remark,
        checker_fender_depan_kanan_remark : this.checker.checker_fender_depan_kanan_remark,
        checker_spion_kiri_remark : this.checker.checker_spion_kiri_remark,
        checker_spion_kanan_remark : this.checker.checker_spion_kanan_remark,
        checker_cover_spion_kiri_remark : this.checker.checker_cover_spion_kiri_remark,
        checker_cover_spion_kanan_remark : this.checker.checker_cover_spion_kanan_remark,
        checker_cover_spion_kiri_remark : this.checker.checker_cover_spion_kiri_remark,
        checker_cover_spion_kanan_remark : this.checker.checker_cover_spion_kanan_remark,
        checker_bemper_depan_remark : this.checker.checker_bemper_depan_remark,
        checker_kaca_depan_remark : this.checker.checker_kaca_depan_remark,
        checker_kaca_belakang_remark : this.checker.checker_kaca_belakang_remark,
        checker_kaca_pintu_depan_kiri_remark : this.checker.checker_kaca_pintu_depan_kiri_remark,
        checker_kaca_pintu_depan_kanan_remark : this.checker.checker_kaca_pintu_depan_kanan_remark,
        checker_kaca_pintu_belakang_kiri_remark : this.checker.checker_kaca_pintu_belakang_kiri_remark,
        checker_kaca_pintu_belakang_kanan_remark : this.checker.checker_kaca_pintu_belakang_kanan_remark,
        checker_pintu_depan_kiri_remark : this.checker.checker_pintu_depan_kiri_remark,
        checker_pintu_depan_kanan_remark : this.checker.checker_pintu_depan_kanan_remark,
        checker_pintu_belakang_kiri_remark : this.checker.checker_pintu_belakang_kiri_remark,
        checker_pintu_belakang_kanan_remark : this.checker.checker_pintu_belakang_kanan_remark,
        checker_fender_belakang_kiri_remark : this.checker.checker_fender_belakang_kiri_remark,
        checker_fender_belakang_kanan_remark : this.checker.checker_fender_belakang_kanan_remark,
        checker_atap_remark : this.checker.checker_atap_remark,
        checker_pintu_belakang_remark : this.checker.checker_pintu_belakang_remark,
        checker_roda_depan_kiri_remark : this.checker.checker_roda_depan_kiri_remark,
        checker_roda_depan_kanan_remark : this.checker.checker_roda_depan_kanan_remark,
        checker_roda_belakang_kiri_remark : this.checker.checker_roda_belakang_kiri_remark,
        checker_roda_belakang_kanan_remark : this.checker.checker_roda_belakang_kanan_remark,
        checker_kap_mesin : this.checker.checker_kap_mesin,
        checker_fender_depan_kiri : this.checker.checker_fender_depan_kiri,
        checker_fender_depan_kanan : this.checker.checker_fender_depan_kanan,
        checker_spion_kiri : this.checker.checker_spion_kiri,
        checker_spion_kanan : this.checker.checker_spion_kanan,
        checker_cover_spion_kiri : this.checker.checker_cover_spion_kiri,
        checker_cover_spion_kanan : this.checker.checker_cover_spion_kanan,
        checker_cover_spion_kiri : this.checker.checker_cover_spion_kiri,
        checker_cover_spion_kanan : this.checker.checker_cover_spion_kanan,
        checker_bemper_depan : this.checker.checker_bemper_depan,
        checker_kaca_depan : this.checker.checker_kaca_depan,
        checker_kaca_belakang : this.checker.checker_kaca_belakang,
        checker_kaca_pintu_depan_kiri : this.checker.checker_kaca_pintu_depan_kiri,
        checker_kaca_pintu_depan_kanan : this.checker.checker_kaca_pintu_depan_kanan,
        checker_kaca_pintu_belakang_kiri : this.checker.checker_kaca_pintu_belakang_kiri,
        checker_kaca_pintu_belakang_kanan : this.checker.checker_kaca_pintu_belakang_kanan,
        checker_pintu_depan_kiri : this.checker.checker_pintu_depan_kiri,
        checker_pintu_depan_kanan : this.checker.checker_pintu_depan_kanan,
        checker_pintu_belakang_kiri : this.checker.checker_pintu_belakang_kiri,
        checker_pintu_belakang_kanan : this.checker.checker_pintu_belakang_kanan,
        checker_fender_belakang_kiri : this.checker.checker_fender_belakang_kiri,
        checker_fender_belakang_kanan : this.checker.checker_fender_belakang_kanan,
        checker_atap : this.checker.checker_atap,
        checker_pintu_belakang : this.checker.checker_pintu_belakang,
        checker_roda_depan_kiri : this.checker.checker_roda_depan_kiri,
        checker_roda_depan_kanan : this.checker.checker_roda_depan_kanan,
        checker_roda_belakang_kiri : this.checker.checker_roda_belakang_kiri,
        checker_roda_belakang_kanan : this.checker.checker_roda_belakang_kanan,




      }

      console.log(data)
      try {
        //kirim data ke server
      await this.$store.dispatch("workshop_checker/add", data);
      //panggil alert succes
      await this.$store.dispatch(
        "alerts/success",
        "Successfully registered."
      );
      //kembali ke list
        // await this.$router.push({name: 'List Checker'});
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        //panggil alert error
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

    },
       //set data yang diambil dari child info
    // dataInfo (value) {
    //   this.checker.keluhan = value
    // },
    
    //checke validasi stiap child sebulum pindah section
    validateStep(name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validateForm()
    },

   
    
  },
  mounted() {
    console.log('Component mounted.')
  }
};
</script>
